<template>
  <div class="hardwareInventory-container">
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="golden" theme="filled" />
          <span>硬件台账</span>
        </a-space>
      </template>
      <span>硬件台账包含位置、设备名称等信息。</span>
    </a-page-header>

    <a-card :bordered="false" style="margin-bottom: 16px">
      <list-layout
        :getTableDataFunc="getTableDataFunc"
        :columnsAll="columnsAll"
        :columnDefaultSelected="columnDefaultSelected"
        :exportFunc="exportFunc"
        :toolsList="['setting', 'reload', 'leftTool', 'export', 'search']"
        :search-type-options="[
          { label: '位置', value: 'location' },
          { label: '设备名称', value: 'name' },
          { label: '品牌', value: 'vendor' },
          { label: '类型', value: 'category' },
          { label: '型号/版本', value: 'model' },
          { label: 'IP 地址', value: 'private_ip' }
        ]"
        :refresh="refresh"
      >
        <template #leftTool>
          <create-button
            v-permission="{action: 'base.inventory.create', effect: 'disabled'}"
            @click="$refs.inputDrawer.show()"
          ></create-button>
        </template>
        <template #rightTool>
          <upload-button
            v-permission="{action: 'base.inventory.update'}"
            @click="$refs.uploadModal.show()"
          ></upload-button>
        </template>

        <template #operation="{ slotProps }">
          <edit-button
            v-permission="{action: 'base.inventory.update', effect: 'disabled'}"
            @click="$refs.inputDrawer.show(slotProps.record.id)"
          ></edit-button>
          <delete-button
            v-permission="{action: 'base.inventory.delete', effect: 'disabled'}"
            @confirm="confirm(slotProps.record.id)"
          ></delete-button>
        </template>
      </list-layout>
    </a-card>

    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
    <upload-modal ref="uploadModal" @confirm="uploadConfirm"></upload-modal>
  </div>
</template>

<script>
import {
  getHardwareInventoryList,
  deleteHardwareInventory,
  exportHardwareInventory
} from '@/api/inventory.js'
import ListLayout from '@/components/ListLayout.vue'
import CreateButton from '@/components/button/CreateButton.vue'
import InputDrawer from './modules/InputDrawer.vue'
import UploadButton from '@/components/button/UploadButton.vue'
import UploadModal from './modules/UploadModal.vue'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'

export default {
  name: 'HardwareInventory',
  components: {
    ListLayout,
    CreateButton,
    InputDrawer,
    UploadButton,
    UploadModal,
    DeleteButton,
    EditButton
  },
  data () {
    return {
      getTableDataFunc: getHardwareInventoryList,
      exportFunc: exportHardwareInventory,
      refresh: false,
      columnsAll: [
        {
          dataIndex: 'location',
          title: '位置',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'location'
          }
        },
        {
          dataIndex: 'name',
          title: '设备名称',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'vendor',
          title: '品牌',
          width: 128,
          ellipsis: true,
          scopedSlots: {
            customRender: 'vendor'
          }
        },
        {
          dataIndex: 'category',
          title: '类型',
          width: 128,
          ellipsis: true,
          scopedSlots: {
            customRender: 'category'
          }
        },
        {
          dataIndex: 'model',
          title: '型号/版本',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'model'
          }
        },
        {
          dataIndex: 'private_ip',
          title: 'IP 地址',
          width: 180,
          ellipsis: true,
          scopedSlots: {
            customRender: 'privateIp'
          }
        },
        {
          dataIndex: 'expires_at',
          title: '维保到期时间',
          width: 180,
          scopedSlots: {
            customRender: 'expiresAt'
          }
        }
      ],
      columnDefaultSelected: [
        'location',
        'name',
        'vendor',
        'category',
        'model',
        'private_ip',
        'expires_at'
      ]
    }
  },
  methods: {
    async confirm (id = '') {
      if (id) {
        await deleteHardwareInventory(id).then(res => {
          this.$message.success(res.message)
        })
      }
      this.refresh = !this.refresh
    },
    uploadConfirm () {
      this.refresh = !this.refresh
    }
  }
}
</script>
